import { Stack, Typography } from '@mui/material'
import { ClassificationReportResponse, ConfidenceInterval } from '@src/types/classificationReport'
import HighlightedValue from './HighlightedValue'

interface ModelComparisonCellProps {
  reports: ClassificationReportResponse['reports']
  intervalIndex: number
  getValue: (interval: ConfidenceInterval) => number
  formatValue?: (value: number) => string
  getBestValue: (values: number[]) => number
  resultType?: 'TP' | 'FP' | 'FN'
  onClick?: (modelName: string, interval: string, resultType: 'TP' | 'FP' | 'FN', value: number) => void
}

const ModelComparisonCell = ({
  reports,
  intervalIndex,
  getValue,
  formatValue = (v) => String(v),
  getBestValue,
  resultType,
  onClick,
}: ModelComparisonCellProps) => {
  const colors = ['#f57c00', '#1976d2', '#9c27b0', '#388e3c']

  return (
    <Stack
      direction="row"
      spacing={0.5}
      alignItems="center"
      justifyContent="center"
      divider={<Typography>|</Typography>}
    >
      {reports.map((modelReport, index) => {
        const color = colors[index % colors.length]
        const interval = modelReport.confidenceIntervals[intervalIndex]
        const value = getValue(interval)
        const allValues = reports.map((r) => getValue(r.confidenceIntervals[intervalIndex]))
        const bestValue = getBestValue(allValues)
        const countBest = allValues.filter((v) => v === bestValue).length
        const isBest = reports.length > 1 && value === bestValue && countBest === 1

        const handleClick = () => {
          if (onClick && resultType && value > 0) {
            onClick(modelReport.modelName, interval.interval, resultType, value)
          }
        }

        return (
          <HighlightedValue
            key={modelReport.modelName}
            value={formatValue(value)}
            color={value > 0 ? color : 'default'}
            isBest={isBest}
            onClick={onClick && resultType && value > 0 ? handleClick : undefined}
          />
        )
      })}
    </Stack>
  )
}

export default ModelComparisonCell
